import { LevelingModule } from './../../../widgets/leveling/leveling.module';
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import {
  DxChartModule,
  DxPieChartModule,
  DxRangeSelectorModule,
  DxDataGridModule,
  DxPopupModule,
  DxSwitchModule,
  DxPopoverModule,
} from "devextreme-angular";
import { CommonModule } from "@angular/common";
import { DevEpressCommonModule } from "src/app/dev-epress-common.module";
import { SupplyForecastOverviewComponent } from "./supply-forecast-overview.component";
import { BookmarkModule } from 'src/app/widgets/bookmark/bookmark.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FiltersGroupModule } from 'src/app/widgets/filters/filters-group/filters-group.module';
import { BookmarkNewComponent } from 'src/app/widgets/bookmark-new/bookmark-new.component';
import { HelpButtonComponent } from 'src/app/widgets/help-button/help-button.component';
import { DxTableControllerDirective } from 'src/app/directives/dx-table-controller.directive';
import { ContainerComponent } from 'src/app/components/container/container.component';
import { WebExportModule } from 'src/app/widgets/web-export/web.export.module';
import { HelpPopoverButtonComponent } from 'src/app/components/help-popover-button/help-popover-button.component';

@NgModule({
  declarations: [SupplyForecastOverviewComponent],
  imports: [
    CommonModule,

	HelpPopoverButtonComponent,

    DxDataGridModule,
    DxRangeSelectorModule,
    DxChartModule,
    DxPieChartModule,
    DevEpressCommonModule,DxSwitchModule,
	ContainerComponent,
	DxTableControllerDirective,
	FiltersGroupModule,
	BookmarkNewComponent,
	HelpButtonComponent,
	DxPopoverModule,WebExportModule,
    DxPopupModule,BookmarkModule,DxPopupModule,FormsModule,ReactiveFormsModule,
    RouterModule.forChild([
      {
        path: "",
        component: SupplyForecastOverviewComponent,
      },
    ]),
		LevelingModule,
  ],
})
export class SupplyForecastOverviewModule {}
